export const enum Routes {
    SPARK_CONFIGURATION = '/spark-configuration',
    LICENSE = '/license',
    LOCAL_UPLOAD = '/local-upload',
    PROFILE = '/profile',
    S3_CONNECTOR = '/s3-connector',
    CREATE_S3_CONNECTOR = '/s3-connector/create',
    EDIT_S3_CONNECTOR = '/s3-connector/edit',
    HTTP_CONNECTOR = '/http-connector',
    CREATE_HTTP_CONNECTOR = '/http-connector/create',
    EDIT_HTTP_CONNECTOR = '/http-connector/edit',
    USER = '/users',
    ROLE = '/roles',
    CREATE_USER = '/user/create',
    EDIT_USER = '/user/edit',
    JOBS = '/jobs',
    RAW_QUERY = '/raw-query',
    PATIENT_EVENTS = '/patient-events',
    ADVANCED_SETTINGS = '/advanced-settings',
    CHATHISTORY = '/chat-history',
    CHATCONVERSATION = '/chat-conversation',
    SOURCE_REGISTRY = '/data-integration/source-registry',
    EDIT_SOURCE = '/data-integration/source-registry/:id',
    SOURCE_STUDY_BROWSER = '/data-integration/source-registry/:sourceId/study-browser',
    DATA_INGESTION = '/data-integration/data-ingestion',

    ADMIN = '/administration',
    KB_MANAGEMENT = '/data-integration/kb-management',

    HOME = '/',
    CHAT = '/co-pilot',
    COHORTS = '/cohort-builder',
    NEW_COHORT = '/cohort-builder/new',
    CLINICAL_TRIALS = '/cohort-builder/clinical-trials',
    CLINICAL_TRIAL_JOB = '/cohort-builder/clinical-trials/:id',
    PATIENTS = '/patient-journey',
    PATIENTS_PAGE = '/patients/:id',
    DATA_CURATION = '/data-curation-studio',
    NEW_DATA_CURATION = '/data-curation-studio/new',
    CURATION_JOB = '/data-curation-studio/:id',
    DOCUMENT_VIEWER = '/data-curation-studio/document-viewer',
    DE_IDENTIFICATION = '/de-identification',

    ONTOLOGIES = '/data-curation-studio/ontologies',
    NEW_ONTOLOGY = '/data-curation-studio/ontologies/new',
    VIEW_ONTOLOGY = '/data-curation-studio/ontologies/view/:id',
    EDIT_ONTOLOGY = '/data-curation-studio/ontologies/edit/:id',
    BUILD_ONTOLOGY = '/data-curation-studio/ontologies/build',

    DEID_PROFILES = '/de-identification/profiles',
    NEW_DEID_PROFILE = '/de-identification/profiles/new',
    VIEW_DEID_PROFILE = '/de-identification/profiles/view/:id',
    EDIT_DEID_PROFILE = '/de-identification/profiles/edit/:id',

    CLINICAL_MEASURES = '/clinical-measures',
    NEW_MEASURE = '/clinical-measures/new',
    FEEDBACK = '/feedback',
    DB_EXPLORER = '/data-integration/db-explorer',
    AUDIT = '/audit-logs',

    DATASETS = '/data-integration/datasets',
    NEW_DATASET = '/data-integration/datasets/new',
    DATASET_DETAILS = '/data-integration/datasets/:id',

    // Agents
    CPG_RAG = '/agents/cpg-rag',
    MCP_DOCS = '/agents/mcp-docs',

    // Registry Standards
    REGISTRY_STANDARDS = '/data-hub/registry-standards',

    // Settings
    SETTINGS = '/settings',
    // Terminology Server
    TERMINOLOGY_SERVER = '/terminology-server',
}
